import React from 'react';
import { Link } from 'react-router-dom';

import aboutImg from '../../assets/img/slider/gemasan-14.svg';

const About = () => {
  return (
    <div id="hakkimizda" className="about__area pb-100 p-relative">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="about__img">
              <img src={aboutImg} alt="" />
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="about__section-box pb-10">
              <h4 className="section-subtitle char-anim">Hakkımızda</h4>
              <h3 className="section-title char-anim">
                Denizdeki Operasyonları Daha Güvenli ve Etkin Hâle Getiriyoruz
              </h3>
            </div>
            <div className="about__content">
              <p className="char-anim-2">
                Kuruluşumuzun temel faaliyet alanı denizcilik teknolojileri kapsamında gemiler için entegre sistemlerin geliştirilmesi ve taşımacılığı kolaylaştıracak yenilikçi çözümler üretilmesidir. 2023 yılında başladığımız yolculuğumuzda, yerli teknolojiler üretmeyi hedefleyerek denizcilik sektörüne yönelik güvenli, verimli ve otonom operasyonlara imkân tanıyan ileri teknoloji sistemler tasarlıyor ve geliştiriyoruz. Su altı operasyonlarında kullanılmak üzere üretilen insansız su altı robotu, karmaşık görevleri gerçekleştirebilen çok fonksiyonlu manipülatör sistemleri ve deniz araçlarına gerçek zamanlı çevresel farkındalık kazandıran yapay zekâ tabanlı seyir destek çözümleri geliştiriyoruz.
              </p>
            </div>
            <div className="about__list-item">
              <ul>
                <li>
                  <i className="far fa-check"></i>
                  <span>Su Altı Robotu (ROV) Geliştirme</span>
                </li>
                <li>
                  <i className="far fa-check"></i>
                  <span>
                    <Link to="/robotkol" style={{ color: 'inherit', textDecoration: 'none' }}>
                      Robot Kol
                    </Link>
                  </span>
                </li>
                <li>
                  <i className="far fa-check"></i>
                  <span>
                    <Link to="/seyir" style={{ color: 'inherit', textDecoration: 'none' }}>
                      Yapay Zeka Destekli Seyir Sistemleri
                    </Link>
                  </span>
                </li>
                <li>
                  <i className="far fa-check"></i>
                  <span>Kamera ve Sensör Sistemleri</span>
                </li>
                <li>
                  <i className="far fa-check"></i>
                  <span>Su Altı Denetim ve Analiz Teknolojileri</span>
                </li>
                <li>
                  <i className="far fa-check"></i>
                  <span>Yerli Alt Bileşen Üretimi</span>
                </li>
              </ul>
            </div>
            <div className="row gx-0">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 about__border-right">
                <div className="about__contact-box d-flex align-items-center">
                  <div className="about__contact-icon">
                    <span>
                      <i className="fas fa-phone-alt"></i>
                    </span>
                  </div>
                  <div className="about__contact-number">
                    <a href="tel:+905313008336">0 (531) 300 83 36</a>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="about__contact-box d-flex align-items-center">
                  <div className="about__contact-icon">
                    <span>
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                  <div className="about__contact-number">
                    <a href="mailto:info@gemasan.com.tr">info@gemasan.com.tr</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
